import { useLocation } from 'react-router-dom';

const useQuery = () => {
  const query: { [key: string]: string } = {};
  new URLSearchParams(useLocation().search).forEach((value, key) => {
    query[key] = value;
  });

  return query;
};

export default useQuery;
